export class Contact {
  constructor(
    public Name: string,    
    public Telephone: string,
    public Email: string,
    public recaptcha: string
  ) { }
}
